// Submits the dashboard satisfaction survey to an n8n webhook, which in turn
// writes the row to a Google Sheet (Google connection lives in n8n, not here).
//
// NOTE: this intentionally does NOT use the shared `api` axios instance from
// makeApiCall.js — that instance injects the PHP-backend base URL and Bearer
// token, which do not apply to the n8n webhook.
//
// The webhook is called with `application/json`. Enable CORS on the n8n Webhook
// node (set "Allowed Origins (CORS)" to your app origin, or `*`) so the browser
// preflight (OPTIONS) succeeds.

export const submitSurvey = async (payload) => {
  const url = process.env.REACT_APP_SURVEY_WEBHOOK_URL;

  if (!url) {
    throw new Error(
      'Survey endpoint (REACT_APP_SURVEY_WEBHOOK_URL) is not configured.',
    );
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Survey submission failed with status ${response.status}.`);
  }

  return response;
};
